import { getSalesOrderReport } from "../../../services/sales/reporting";
import moment from 'moment';

export default {
    namespaced: true,
    state: {
        data: [],
        from : moment().startOf("month").format("YYYY-MM-DD"),
        to: moment().endOf("month").format("YYYY-MM-DD"),
        invoiceFrom : moment().startOf("month").format("YYYY-MM-DD"),
        invoiceTo: moment().endOf("month").format("YYYY-MM-DD"),
        loading: false,
        errors: []
    },
    getters: {
        data: state => state.data,
        from: state => state.from,
        to: state => state.to,
        invoiceFrom: state => state.invoiceFrom,
        invoiceTo: state => state.invoiceTo,
        loading: state => state.loading,
        errors: state => state.errors,
        hasErrors: state => state.errors.length > 0
    },
    mutations: {
        data: (state, payload) => state.data = payload,
        from: (state, payload) => state.from = payload,
        to: (state, payload) => state.to = payload,
        invoiceFrom: (state, payload) => state.invoiceFrom = payload,
        invoiceTo: (state, payload) => state.invoiceTo = payload,
        loading: (state, payload) => state.loading = payload,
        errors: (state, payload) => state.errors = payload
    },
    actions: {
        get({commit, state}) {
            return new Promise((resolve, reject) => {
                commit("loading", true);
                getSalesOrderReport({from: state.from, to: state.to, invoiceFrom: state.invoiceFrom, invoiceTo: state.invoiceTo})
                    .then(response => {
                        commit("data", response.data);
                        resolve(response);
                    }).catch(error => {
                        reject(error);
                    }).finally(() => {
                        commit("loading", false);
                    })
            });
        },
        updateParams({commit, dispatch}, payload) {
            commit("from", payload.from);
            commit("to", payload.to);
            commit("invoiceFrom", payload.invoiceFrom);
            commit("invoiceTo", payload.invoiceTo);
            dispatch("get");
        }
    }
}